import { lazy, Suspense } from "react";
import Loader from '../custom/loader/main'

const Main = lazy(() => import('../components/report/pendingUpload/main'))

const PendingUpload = () =>{


    return(
        <Suspense fallback={<Loader/>}>
            <Main/>
        </Suspense>
    )


}

export default PendingUpload;